import { render } from "./BarChartIcon.vue?vue&type=template&id=7ea38522"
import script from "./BarChartIcon.vue?vue&type=script&lang=js"
export * from "./BarChartIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__